// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"b0f01fa0","453":"45884f98","455":"a50913e5","500":"f05c6ab9","531":"9f4873c3","977":"c6d5a075"}[chunkId] + ".chunk.js";
};